<div
  class="search"
  (click)="showInput()"
  [ngClass]="{ 'show-search-input': isShowInput }"
  >
  <mat-icon class="search-icon" [ngClass]="{ 'open-search': isShowInput }"
    >search</mat-icon
    >
    @if (isShowInput) {
      <input class="search-input" placeholder="Search..." />
    }
  </div>
